import { Link } from 'react-router-dom';

// Renders assistant text: strips bold markers, turns [label](/path) into in-app links.
export default function RichText({ text, testid }) {
  const parts = [];
  const re = /\[([^\]]+)\]\(([^)\s]+)\)/g;
  const clean = (text || '').replace(/\*\*/g, '');
  let last = 0;
  let m;
  while ((m = re.exec(clean))) {
    if (m.index > last) parts.push(clean.slice(last, m.index));
    const [, label, href] = m;
    parts.push(
      href.startsWith('/') ? (
        <Link key={m.index} to={href} className="underline text-[#00D26A] hover:text-[#FFD700]" data-testid={`${testid}-link`}>{label}</Link>
      ) : (
        <a key={m.index} href={href} target="_blank" rel="noreferrer" className="underline text-[#00D26A]">{label}</a>
      ),
    );
    last = m.index + m[0].length;
  }
  if (last < clean.length) parts.push(clean.slice(last));
  return <>{parts}</>;
}
